export const getAmount = ({ unitQuantityString, unit }) => {
  if (!unitQuantityString || !unit) {
    return null
  }
  return `${unitQuantityString} ${unit}`
}
